import { Component, computed, inject, signal } from '@angular/core';
import { CartService } from '../../services/cart.service';

const DISMISS_KEY = 'mmtess_member_banner_dismissed';

/**
 * Slim top banner shown while member (discounted) pricing is active — i.e. the viewer is a
 * member, or has added the membership to the current order. Dismissible for the session.
 */
@Component({
  selector: 'app-member-banner',
  template: `
    @if (visible()) {
      <div class="relative bg-black text-white text-center text-[13px] md:text-[14px] font-semibold tracking-wide py-2 px-10">
        NOW SHOPPING AT <span class="text-[#ff0000]">MEMBERSHIP</span> PRICES
        <button (click)="dismiss()" aria-label="Dismiss"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-white/70 hover:text-white transition-colors">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M6 6l12 12M18 6L6 18"/></svg>
        </button>
      </div>
    }
  `,
})
export class MemberBanner {
  private cart = inject(CartService);
  private dismissed = signal<boolean>(this.loadDismissed());
  readonly visible = computed(() => this.cart.isMemberPricing() && !this.dismissed());

  private loadDismissed(): boolean {
    try { return sessionStorage.getItem(DISMISS_KEY) === '1'; } catch { return false; }
  }
  dismiss(): void {
    this.dismissed.set(true);
    try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch { /* ignore */ }
  }
}
